/**
 * Bilingual copy for the default SeoHead title/description of the Layout component.
 * `en` holds the exact original English defaults; `km` mirrors them in Khmer.
 */
export const en = {
  defaultTitle: 'AKAS Blog',
  defaultDescription: 'AKAS cloud ERP for growing businesses',
};

export type Copy = typeof en;

export const km: Copy = {
  defaultTitle: 'ប្លុក AKAS',
  defaultDescription: 'ប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម AKAS លើពពក សម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន',
};
